"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unloadLock = void 0;
const __1 = require("..");
let unloadLockEnabled = false;
let unloadLockCallback = undefined;
function preventUnload(e) {
    e.preventDefault();
    (0, __1.set)(e, 'returnValue', '');
}
exports.unloadLock = {
    enable(lockCallback) {
        var _a;
        if (unloadLockEnabled) {
            console.warn('WARNING: unloadLock is already enabled. Using it in multiple places at the same time may lead to unexpected behaviour.');
        }
        unloadLockEnabled = true;
        exports.unloadLock.historyIndex = (_a = window.history.state) === null || _a === void 0 ? void 0 : _a.index;
        window.addEventListener('beforeunload', preventUnload);
        unloadLockCallback = lockCallback;
    },
    disable() {
        unloadLockEnabled = false;
        window.removeEventListener('beforeunload', preventUnload);
        exports.unloadLock.historyIndex = undefined;
        unloadLockCallback = undefined;
    },
    isEnabled() {
        return unloadLockEnabled;
    },
    callback(targetIndex) {
        if (unloadLockCallback) {
            unloadLockCallback(() => {
                var _a;
                exports.unloadLock.disable();
                const currentIndex = (_a = window.history.state) === null || _a === void 0 ? void 0 : _a.index;
                if (typeof currentIndex === 'number') {
                    window.history.go(targetIndex - currentIndex);
                }
                else {
                    console.error(`ERROR: Unable to detect target page. Missing index.`);
                }
            });
        }
    },
    historyIndex: undefined,
};
